import React from 'react'
import { srcImagesFile, srcPersonFile } from '../../utilities/FileUtil'

export default function Media({path,alt='images',type = "images",typefile ='', style = {},className = "img-responsive"}) {

    const renderPathImg = () =>{
        if(typefile && typefile === 'person'){
            return srcPersonFile(path)
        }else{
            return srcImagesFile(path)
        }
    }
    
    const renderMedia = () =>{

        // let typePath = path

        if(type && type === 'video'){
            return (
                <video className={className} controls style={style} >
                    <source 
                        src={path}
                        // src = "http://sitdev.dyndns.org:9104/pic/Profile/ALL/U$c16/20211201101212_c16.avi"
                        type="video/mp4"
                    />
                </video>
            )

        }else if(type && type === 'images'){
            return (
                <img
                    className= {className}
                    alt= {alt}
                    {...renderPathImg()}
                    style ={style}
                />
            )
        }
    }

    return (
        <>
            {renderMedia()}  
        </>
    )
}
